export const BUTTON_LABELS = {
  copyIssueLink: 'Copy permalink',
  deleteIssue: 'Delete permanently',
  editIssue: 'Edit issue',
  transferIssue: 'Transfer issue',
  tryAgain: 'Try again',
  updateComment: 'Update Comment',
  nextItem: 'Go to next item (j)',
  previousItem: 'Go to previous item (k)',
  new: 'New issue',
  cancel: 'Cancel',
  submitIssueTitleEdit: 'Save',
  closePanel: 'Close panel',
  changeIssueType: 'Change issue type',
  changeType: 'Change type',
}
